import styled from 'styled-components';

export const TabContainer = styled.div`
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
`;

export const TabList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
`;

export const TabButton = styled.button`
    background-color: ${props => props.active ? '#e0e0e0' : '#f9f9f9'};
    border: 1px solid #ccc;
    border-radius: 6px 6px 0 0;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 0.95rem;
    min-width: 100px;
    text-align: center;
    transition: background-color 0.3s;

    &:hover {
        background-color: ${props => props.active ? '#d5d5d5' : '#eee'};
    }

    @media (max-width: 768px) {
        flex: 1 1 45%;
        font-size: 0.9rem;
    }

    @media (max-width: 480px) {
        flex: 1 1 100%;
        font-size: 0.85rem;
    }
`;

export const TabPanel = styled.div`
    padding: 1rem;
`;
